import React from "react";
import { string } from "prop-types";

import MyProfile from "../../molecules/MyProfile";
import ProfileContainer from "../../rows/ProfileContainer";

const ProfilePage = ({ currentPath }) => (
  <ProfileContainer type="profile" currentPath={currentPath} hideTopAd={true}>
    <MyProfile currentPath={currentPath} />
  </ProfileContainer>
);

ProfilePage.propTypes = {
  currentPath: string
};

export { ProfilePage };
